// How long a sign-in transaction lives, from the login screen to the callback. The server stores
// it for that long, and the login screen renews it before it runs out.
export const TX_TTL_MS = 10 * 60 * 1000;
